import React from "react";
function ScoringSection(props) {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="scoring-div mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-[#051D62]">
          {props.score.header}
        </h2>

        {/* Subtitle */}
        <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
          {props.score.desc}
        </p>

        {/* Cards Container */}
        <div className="gap-8 grid grid-cols-1 lg:flex lg:flex-wrap lg:gap-8 lg:justify-center mt-12 sm:grid-cols-2 text-left">
          {props.score.cards.map((element, id) => (
            <div
              key={id}
              className="border border-gray-300 rounded-xl p-6 shadow-sm hover:shadow-lg transition w-full sm:w-auto lg:w-[30%]"
            >
              <img
                src={element.img}
                alt="icon"
                className="h-10 mb-4  lg:mx-0"
              />
              <h3 className="font-semibold text-lg text-[#051D62]">
                {element.header}
              </h3>
              <p className="text-gray-600 text-sm mt-1">{element.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const LanguageLearnMore = (props) => {
  const data = props.learnMoreData;
  const pageName = data.pageName;
  return (
    <div className="language-learn-more w-full flex flex-col">
      {/* ---------- HERO SECTION ---------- */}
      <section className="bg-white hero-section">
        <div className="mx-auto grid md:grid-cols-2 gap-10">
          {/* Left text */}
          <div className="lan-learn-more-desktop" style={{}}>
            <h1 className="text-3xl font-bold leading-tight text-[#101828]">
              {data.heroSection.header1} <br /> {data.heroSection.header2}
            </h1>
            <p className="text-gray-600 mt-4 text-[#574D49] lan-learn-more-hero-desc">
              {data.heroSection.desc}
            </p>
          </div>

          {/* Right image */}
          <img
            src={data.heroSection.rightImg}
            alt="Students"
            className="w-full rounded-lg object-cover"
          />
        </div>
      </section>

      {/* ---------- ABOUT TEST SECTION ---------- */}
      <section className="about-test-section  py-10">
        <div
          style={{}}
          className="about-div mx-auto grid md:grid-cols-2 gap-10 items-start"
        >
          {/* Image */}
          <img
            src={data.aboutTestSection.img}
            alt="Test info"
            className="w-full rounded-lg object-cover shadow"
          />

          {/* Text */}
          <div className="p-4">
            <h2 className="text-2xl md:text-3xl font-bold text-[#051D62]">
              {data.aboutTestSection.header}
            </h2>
            <p className="text-gray-600 mt-4 leading-relaxed text-[#455A64]">
              {data.aboutTestSection.desc1}
            </p>
            {data.aboutTestSection.descImg && (
              <span className="about-test-sec-desc-img-container">
                <img
                  src={data.aboutTestSection.descImg}
                  alt="Test info"
                  className="about-test-sec-desc-img rounded-lg object-cover "
                />
              </span>
            )}

            <p className="text-gray-600 mt-3 text-[#455A64]">
              {data.aboutTestSection.desc2}
            </p>
          </div>
        </div>
      </section>

      {/* ---------- DIFFERENCE SECTION ---------- */}
      {pageName === "IELTS" ? (
        <ScoringSection score={data.scoreSection} />
      ) : (
        <section className="bg-[#052A63] px-6 text-white py-20">
          <div className="difference-div mx-auto">
            {/* Heading + Right Paragraph */}
            <div className="flex flex-col md:flex-row justify-between gap-8">
              {/* Left heading */}
              <h2 className="text-3xl md:text-4xl font-bold leading-snug max-w-lg">
                {data.differenceSection.header}
              </h2>

              {/* Right text */}
              <p className="text-gray-200 max-w-xl">
                {data.differenceSection.desc}
              </p>
            </div>

            {/* Four cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-14">
              {/* Card  */}
              {data.differenceSection.cards.map((ele, idx) => (
                <div
                  key={idx}
                  className="bg-white text-[#052A63] p-6 rounded-2xl shadow-lg"
                >
                  <div className="mb-4">
                    <img src={ele.img} alt="icon" className="h-10" />
                  </div>
                  <h3 className="font-bold text-lg text-[#051D62]">
                    {ele.header}
                  </h3>
                  <p className="mt-2 text-sm text-gray-700">{ele.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ---------- TEST FORMAT SECTION ---------- */}
      {pageName === "PTE" ? (
        <ScoringSection score={data.scoreSection} />
      ) : (
        <section className="bg-white  py-20 test-format-section">
          <div className="test-format-div mx-auto text-center">
            {/* Title */}
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#051D62]">
              {data.testFormatSection.header}
            </h2>

            {/* Subtitle */}
            <p className="text-gray-600 max-w-3xl mx-auto text-[#4A5565]">
              {data.testFormatSection.desc}
            </p>

            {/* Table */}
            <div className="hidden md:block overflow-x-auto mt-12">
              <table className="w-full border border-gray-300 rounded-xl overflow-hidden text-left text-sm">
                {/* Table Header */}
                <thead className="bg-[#2F5ED9] text-white text-sm">
                  <tr>
                    {data.testFormatSection.tableData.rowHeader.map(
                      (element, iny) => (
                        <th key={iny} className="p-4 font-semibold text-[#fff]">
                          {element}
                        </th>
                      )
                    )}
                  </tr>
                </thead>

                {/* Body */}
                <tbody className="text-gray-700">
                  {/* Row  */}
                  {data.testFormatSection.tableData.rowData.map((row, ind) => (
                    <tr key={ind} className="border-b">
                      <td className="p-4 font-medium text-[#4A5565]">
                        {row.column1}
                      </td>
                      <td className="p-4 text-[#4A5565]">{row.column2}</td>
                      <td className="p-4 text-[#4A5565]">
                        {Array.isArray(row.column3) ? (
                          <ul className="list-disc pl-5 space-y-1">
                            {row.column3.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        ) : (
                          row.column3
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* ---------------- MOBILE VIEW ---------------- */}
            <div className="md:hidden mt-8 border border-gray-200 rounded-xl">
              {data.testFormatSection.tableData.rowData.map((row, ind) => (
                <div
                  key={ind}
                  className="bg-white p-6 shadow-sm text-left border-bottom border-2 border-primary"
                >
                  {/* Section 0 */}
                  <div className="mt-4">
                    <p className="font-[20px] font-semibold text[#4A5565] tracking-wide">
                      {data.testFormatSection.tableData.rowHeader[0]}
                    </p>
                    <p className="font-[18px] mt-1 text-[#051D62]">
                      {row.column1}
                    </p>
                  </div>
                  {/* Section 1 */}
                  <div className="mt-4">
                    <p className="font-[20px] font-semibold text[#4A5565] tracking-wide">
                      {data.testFormatSection.tableData.rowHeader[1]}
                    </p>
                    <p className="font-[18px] mt-1 text-[#051D62]">
                      {row.column2}
                    </p>
                  </div>
                  {/* Section 2 */}
                  {data.testFormatSection.tableData.rowHeader[2] && (
                    <div className="mt-4">
                      <p className="font-[20px] font-semibold text[#4A5565] tracking-wide">
                        {data.testFormatSection.tableData.rowHeader[2]}
                      </p>

                      {Array.isArray(row.column3) ? (
                        <ul className="list-disc ml-5 mt-1 space-y-1 text-sm text-gray-600">
                          {row.column3.map((item, idx) => (
                            <li
                              key={idx}
                              className="font-[18px] mt-1 text-[#051D62]"
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="font-[18px] mt-1 text-[#051D62]">
                          {row.column3}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default LanguageLearnMore;
